import './cbar-datatable-runtime.js';

window.Vaadin = window.Vaadin || {};
window.Vaadin.suppressPostFinalizeStylesWarning = true;
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
window.dayjs = dayjs;

